import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { auth, db } from "./FirebaseConfig";
import { doc, getDoc } from "firebase/firestore";

const SellerRoute = ({ children, adminEmails }) => {
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    const checkRole = async () => {
      const user = auth.currentUser;
      if (!user) return setAllowed(false);

      const email = user.email;

      // Allow if admin
      if (adminEmails.includes(email)) {
        return setAllowed(true);
      }

      // Otherwise check if seller
      const docRef = doc(db, "profiles", user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists() && docSnap.data().role === "seller") {
        setAllowed(true);
      } else {
        setAllowed(false);
      }
    };

    checkRole();
  }, [adminEmails]);

  if (allowed === null) return <p className="text-center mt-10 text-white">Checking access...</p>;

  return allowed ? children : <Navigate to="/unauthorized" />;
};

export default SellerRoute;
